import { render } from "./ClubBenefitsSection.vue?vue&type=template&id=7773bcde&scoped=true"
import script from "./ClubBenefitsSection.vue?vue&type=script&lang=js"
export * from "./ClubBenefitsSection.vue?vue&type=script&lang=js"

import "./ClubBenefitsSection.vue?vue&type=style&index=0&id=7773bcde&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7773bcde"]])

export default __exports__